/**
 * `countByTab(rows, tabIds, tabOf)` — THE per-tab count for a list page's tab
 * strip: `{ all: rows.length, <id>: n, … }`. Extracted 2026-09-30 when My Orders
 * took tabs beside Department Orders' queue tabs, so the two strips cannot
 * count differently.
 *
 * 🔑 `all` is the ROW count, never a sum of the other tabs — so a row whose
 * status the mapping does not recognise (`tabOf` → `null`) still counts in
 * All, and All keeps meaning all if a sum identity ever breaks.
 * Every non-`all` id starts at `0`, so an empty tab still reports a real `0`
 * (`ui/Tabs` renders it: `count != null`).
 * A `tabOf` answer that is not one of `tabIds` is ignored, never invented.
 */
export function countByTab(rows, tabIds, tabOf) {
  const counts = { all: rows.length };
  tabIds.forEach((id) => { if (id !== 'all') counts[id] = 0; });
  // `tabOf` may answer ONE id or an ARRAY of ids (an order in two queues — Dept Orders'
  // `orderQueueTabs`, 2026-10-28); each named tab counts the row once.
  rows.forEach((row) => {
    const answer = tabOf(row);
    const ids = Array.isArray(answer) ? answer : [answer];
    ids.forEach((id) => {
      if (id != null && id !== 'all' && Object.prototype.hasOwnProperty.call(counts, id)) counts[id] += 1;
    });
  });
  return counts;
}
